import type { SeriesStreakItem } from './types'

export default function getSeriesStreakItemTooltip(item: SeriesStreakItem): string {
  const { attended, attendanceRequired, hasEnded } = item

  if (!hasEnded) {
    return 'Upcoming session'
  }

  return `${attended ? 'Attended' : 'Missed'} ${attendanceRequired ? 'a required' : 'an optional'} session`
}
